module.exports = __webpack_public_path__ + "static/monfina-2a167ef1bc53b8a4a2dd12f22830b6a2.png";